﻿import { Component } from '@angular/core';
import { RestService } from 'src/app/_services/rest.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { Observable, BehaviorSubject } from 'rxjs';
import { Param } from '../../../_models';


@Component({ templateUrl: 'edit.param.component.html' })
export class EditParamComponent {

    oParam: Observable<Param>;
    paramForm: FormGroup;
    param: Param;
    saving = false;
    submitted = false;

    constructor(private restService: RestService, private route: ActivatedRoute, private router: Router) {
        this.route.params.subscribe(params => {
            if (params['id'] > 0) {
                this.oParam = this.getParam(params['id']);
            } else {
                const tmp = new Param();
                tmp.id = 0;
                this.oParam = new BehaviorSubject<any>(tmp).asObservable();
            }
            this.oParam.subscribe(param => {
                this.createForm(param);
            });
        });

    }

    private createForm(param: Param) {
        this.param = param;
        this.paramForm = new FormGroup({
            'clave': new FormControl(param.clave, Validators.required),
            'valor': new FormControl(param.valor, Validators.required)
        });
    }

    get clave() { return this.paramForm.get('clave'); }

    get valor() { return this.paramForm.get('valor'); }

    private getParam(id: string): Observable<Param> {
        return this.restService.get('/rest-api/root/param/' + id);
    }

    cancelar() {
        this.router.navigate(['/root/params/']);
    }

    get f() { return this.paramForm.controls; }

    onSubmit() {
        this.submitted = true;

        // stop here if form is invalid
        if (this.paramForm.invalid) {
            return;
        }

        this.saving = true;
        const value = this.paramForm.value;
        this.param.clave = value.clave;
        this.param.valor = value.valor;

        this.restService.post('/rest-api/root/param', this.param)
            .subscribe(
                data => {
                    this.saving = false;
                    this.cancelar();
                })
            ;

    }

}
